import { SetCenterRightIcon } from './SetCenterRightIcon';

/**
 * author: Simran
 * id 614D2F8D-5170-4FE8-87C7-419903F205CB
 * name set-center-right
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-center-right.svg
 * tags
 * - Database 
 */
export const OuterJoinRightIcon = SetCenterRightIcon;
export default OuterJoinRightIcon